// Centralized currency symbols and helper to reuse across the app
export const currencySymbols = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  CHF: 'CHF',
  CAD: '$',
  AUD: '$',
  NZD: '$',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
  TRY: '₺',
  RUB: '₽',
  INR: '₹',
  THB: '฿',
  SGD: '$',
  HKD: '$',
  MXD: '$',
  MXN: '$',
  BRL: 'R$',
  AED: 'د.إ',
  DZD: 'دج',
  SAR: '﷼'
};

export const getCurrencySymbol = (currency) => {
  return currencySymbols[currency] || currency;
};

export default getCurrencySymbol;
